module.exports = __webpack_public_path__ + "static/media/make-up_brush.f150bc09.f150bc09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/make-up_brush.f150bc09.jpg
// module id = 476
// module chunks = 0